<button
  type="button"
  class="btn btn-menu capitalize"
  [disabled]="disabled"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  [matMenuTriggerFor]="multiSelectMenu"
>
  {{ selectedSet.size | i18nPlural: buttonText | craftTerm: { count: selectedSet.size } }}
  <craft-icon class="svg-icon text-size-11 icon-arrow" name="arrows--arrow-head-down-sm"></craft-icon>
  <craft-icon
    class="svg-icon icon-remove text-size-8"
    matTooltip="Remove filter"
    matTooltipPosition="above"
    (click)="removeFilter($event)"
    name="general--close-sm"
  ></craft-icon>
</button>

<craft-icon
  class="svg-icon icon-clear text-size-9"
  matTooltip="Clear filter"
  matTooltipPosition="above"
  (click)="clearAndApply()"
  name="general--close-sm"
></craft-icon>

<mat-menu #multiSelectMenu="matMenu" class="linked-items-menu">
  <ng-template matMenuContent="">
    <div (click)="$event.stopPropagation()">
      <!--Head-->
      <div *ngIf="linkedItems.size > 0" class="panel-head">
        <div *ngFor="let item of linkedItems | keyvalue; trackBy: identify" class="head-item">
          <button
            matTooltip="Remove filter item"
            matTooltipPosition="above"
            type="button"
            class="btn"
            (click)="selectItem(item.value)"
          >
            <craft-icon class="svg-icon text-size-9" name="general--close-sm"></craft-icon>
          </button>

          <div class="item-content ellipsis">
            <craft-icon class="svg-icon text-size-11 shrink-0" [name]="ICONS[item.value.itemTypeId]"></craft-icon>
            <span class="ellipsis">{{ item.value.title }}</span>
          </div>
        </div>
      </div>

      <!--Search-->
      <div class="menu-search mat-mdc-menu-item d-flex align-items-center">
        <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
        <input type="text" #searchInput placeholder="Search items to link" [formControl]="searchControl" />
      </div>

      <!--Content-->
      <div class="menu-scroll">
        <!--Product-->
        <div
          *ngFor="let feature of filteredItems | async; trackBy: identify"
          [ngClass]="{ open: openedItems.has(feature.guid) }"
          (click)="toggleParent(feature)"
        >
          <div class="d-flex align-items-center gap-8 ellipsis" mat-menu-item="">
            <craft-icon class="svg-icon text-size-11 arrow" name="arrows--arrow-right-b-sm"></craft-icon>
            <craft-icon class="svg-icon text-size-11" name="item--theme-sm"></craft-icon>
            <span class="ellipsis" title="{{ feature.title }}">{{ feature.title }}</span>
          </div>

          <!--Epic-->
          <div
            *ngFor="let topic of feature.children; trackBy: identify"
            [ngClass]="{ open: openedItems.has(topic.guid) }"
            class="child"
            (click)="toggleParent(topic, $event)"
          >
            <div class="d-flex align-items-center gap-6" mat-menu-item="">
              <craft-icon class="svg-icon text-size-11 arrow" name="arrows--arrow-right-b-sm"></craft-icon>
              <mat-checkbox [checked]="linkedItems.has(topic.guid)" (change)="selectItem(topic)" class="small ellipsis">
                <span class="d-flex align-items-center gap-4 ellipsis">
                  <craft-icon class="svg-icon text-size-11 d-flex" name="item--epic-sm"></craft-icon>
                  <span class="ellipsis" title="{{ topic.title }}">{{ topic.title }}</span>
                </span>
              </mat-checkbox>
              <a
                class="d-flex"
                [href]="'product/@productId/item/@itemId' | appUrl: productId : topic.shortId"
                target="_blank"
              >
                <craft-icon class="svg-icon text-size-15" name="general--viewin-md"></craft-icon>
              </a>
            </div>

            <!--Story-->
            <div *ngFor="let page of topic.children; trackBy: identify" class="child">
              <div class="d-flex align-items-center gap-6" mat-menu-item="">
                <mat-checkbox [checked]="linkedItems.has(page.id)" (change)="selectItem(page)" class="small ellipsis">
                  <span class="d-flex align-items-center gap-4 ellipsis">
                    <craft-icon class="svg-icon text-size-11" [name]="ICONS[page.itemTypeId]"></craft-icon>
                    <span class="ellipsis" title="{{ page.title }}">{{ page.title }}</span>
                  </span>
                </mat-checkbox>
                <a
                  class="d-flex"
                  [href]="'product/@productId/item/@itemId' | appUrl: productId : page.shortId"
                  target="_blank"
                >
                  <craft-icon class="svg-icon text-size-15" name="general--viewin-md"></craft-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-footer">
      <button (click)="clearSelected($event)" type="button" class="btn">Clear</button>
    </div>
  </ng-template>
</mat-menu>
